(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.header-section');
      this.headerBounds = {};
      this.currentScrollTop = 0;

      this.onScrollHandler = this.onScroll.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (document.querySelector('.product_sticky_bar_bottom')) {
    document.querySelector('footer').style.paddingBottom = '100px';
  }
  // sticky add to cart
  document.querySelector('.sticky_buttons .addtocart').addEventListener('click', function () {
    document.querySelector('input.add-to-cart-btn').click();
  });
  // change qty
  document.querySelector('.right_sticky_part #quantity-sticky').addEventListener('change', (e) => {
    document.querySelector('.main__product #quantity').value = e.target.value;
    document.querySelector('.sticky_qty_hidden').value = e.target.value;
  });

  // change variant
  waitForElm('.middle_sticky_bar select').then((elm) => {
    document.querySelector('.middle_sticky_bar select').addEventListener('change', (e) => {
      document.querySelector('.product_top_form form select').value = e.target.value;
      document.querySelector('.sticky_buttons form select').value = e.target.value;
    });
  });
  waitForElm('.complementary-products .flickity-viewport').then((elm) => {
    document.querySelector('.complementary-products').style.visibility = 'visible';
  });

  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });

  observer.observe(productRecommendationsSection);

  document.addEventListener('DOMContentLoaded', function () {
    observer.observe(productRecommendationsSection);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }

            setTimeout(() => {
              var elem = this.querySelector('.recommend_product_listing');
              var recommendFlkty = new Flickity(elem, {
                avoidReflow: true,
                pageDots: false,
                prevNextButtons: true,
                groupCells: true,
                lazyLoad: true,
                wrapAround: true,
                cellAlign: 'left',
                arrowShape: 'M 10,40 L 50,00 L 50,30 L 90,30 L 90,50 L 50,50 L 50,80 Z',
              });

              var focusableElements = [
                'a',
                'input',
                'select',
                'button',
                'iframe',
                'div[role="button"]',
                'model-viewer',
                'video',
                'lite-youtube',
                'lite-vimeo',
              ];
              recommendFlkty.on('select', function (index) {
                recommendFlkty.cells.forEach(function (cell) {
                  cell.element.tabIndex = -1;
                  focusableElements.forEach((focusableElement) => {
                    cell.element.querySelectorAll(focusableElement).forEach((sliderLink) => {
                      sliderLink.tabIndex = -1;
                    });
                  });
                });
                recommendFlkty.selectedCells.forEach(function (cell) {
                  cell.element.tabIndex = 0;
                  focusableElements.forEach((focusableElement) => {
                    cell.element.querySelectorAll(focusableElement).forEach((sliderLink) => {
                      sliderLink.tabIndex = 0;
                    });
                  });
                });
              });
              recommendFlkty.on('settle', function (index) {
                recommendFlkty.cells.forEach(function (cell) {
                  cell.element.tabIndex = -1;
                  focusableElements.forEach((focusableElement) => {
                    cell.element.querySelectorAll(focusableElement).forEach((sliderLink) => {
                      sliderLink.tabIndex = -1;
                    });
                  });
                });
                recommendFlkty.selectedCells.forEach(function (cell) {
                  cell.element.tabIndex = 0;
                  focusableElements.forEach((focusableElement) => {
                    cell.element.querySelectorAll(focusableElement).forEach((sliderLink) => {
                      sliderLink.tabIndex = 0;
                    });
                  });
                });
              });
            }, 500);
            // animateElements()
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
